import React from 'react';
import { getAnnualBillingSummaryParts } from '../helpers/subscriptionBilling';

// "Jährliche Abrechnung: 54,00 € / Jahr - Sie sparen 20% gegenüber monatlicher Abrechnung."
// with "Sie sparen 20%" in bold. Without a monthly counterpart in `subscriptionTypes` it shows
// only the yearly amount.
export default function AnnualBillingSummary({ subscriptionType, subscriptionTypes = [], className, style }) {
  const { yearly, savings } = getAnnualBillingSummaryParts(subscriptionType, subscriptionTypes);
  return (
    <span className={className} style={style}>
      {yearly}
      {savings ? <> - <b>{savings}</b> gegenüber monatlicher Abrechnung.</> : '.'}
    </span>
  );
}
